<template>
  <div class="page-content-wrapper user-list-page"  v-check-permission="'list-registration-to-examination-tables'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Listas de inscriptos a mesas de exámen</h4>
              <p class="text-muted m-b-30 font-14">Desde aquí podras administrar las listas de los inscriptos a las mesas de exámen.</p>

              <div class="table-rep-plugin">

                <div class="row">

                  <div class="col-md-3 mb-3" v-bind:class="{ 'has-danger': $v.params.examinationTable.$error }">
                    <select id="examinationTable" class="custom-select form-control" v-model="params.examinationTable">
                      <option :value="null">Mesa de Exámen</option>
                      <option v-for="examinationTablesItem in listOfExaminationTables.docs" v-bind:value="examinationTablesItem._id">
                        {{ examinationTablesItem.name }} <small v-if="examinationTablesItem.called">({{ examinationTablesItem.called }})</small>
                      </option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.params.examinationTable.required && $v.params.examinationTable.$error">Seleccionar la mesa de exámen.</div>
                  </div>

                  <div class="col-md-3 mb-3" v-bind:class="{ 'has-danger': $v.params.career.$error }">
                    <select id="career" class="custom-select form-control" v-model="params.career" @change="getListOfStudyPlans()">
                      <option :value="null">Carrera</option>
                      <option v-for="career in listOfCareers" v-bind:value="career._id">
                        {{ career.name }}
                      </option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.params.career.required && $v.params.career.$error">Seleccionar la carrera.</div>
                  </div>

                  <div class="col-md-3 mb-3" v-if="params.career" v-bind:class="{ 'has-danger': $v.params.studyPlan.$error }">
                    <select id="studyPlan" class="custom-select form-control" v-model="params.studyPlan" @change="getListOfLevels()">
                      <option :value="null">Plan de estudios</option>
                      <option v-for="studyPlanItem in listOfStudyPlans" v-bind:value="studyPlanItem._id">
                        Res. {{ studyPlanItem.resolution }} ({{ studyPlanItem.fileNumber }})
                      </option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.params.studyPlan.required && $v.params.studyPlan.$error">Seleccionar el plan de estudio.</div>
                  </div>

                  <div class="col-md-3 mb-3" v-if="params.studyPlan" v-bind:class="{ 'has-danger': $v.params.level.$error }">
                    <select id="level" class="custom-select form-control" v-model="params.level" @change="getListOfSubjects()">
                      <option :value="null">Año</option>
                      <option v-for="levelItem in listOfLevels" v-bind:value="levelItem._id">
                        {{ levelItem.name }}
                      </option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.params.level.required && $v.params.level.$error">Seleccionar el año.</div>
                  </div>

                  <div class="col-md-3 mb-3" v-if="params.level" v-bind:class="{ 'has-danger': $v.params.subject.$error }">
                    <select id="subject" class="custom-select form-control" v-model="params.subject">
                      <option :value="null">Materia</option>
                      <option v-for="subjectItem in listOfSubjects" v-bind:value="subjectItem._id">
                        {{ subjectItem.curricularSpace }} <small>{{ getSubjectDuration(subjectItem.duration) }}</small>
                      </option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.params.subject.required && $v.params.subject.$error">Seleccionar la mesa de materia.</div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <button class="btn btn-primary bootstrap-touchspin-up" @click="search()" title="Buscar" type="button"><i class="fa fa-search"></i></button>
                    <button class="btn btn-primary" @click="clearFilters()">Limpiar</button>
                    <button class="btn btn-outline-info download" @click="download()" title="Descargar"><i class="fa fa-download" aria-hidden="true"></i></button>
                  </div>

                  <div class="col-md-2 mb-3">
                    <router-link to="/edit-inscripcion-into-registration-to-examination-tables" class="btn btn-info waves-effect waves-light">Inscribir alumno</router-link>
                  </div>

                </div>

                <div class="table-responsive b-0" data-pattern="priority-columns">

                  <div class="row pull-right mb-2">
                    <div class="col-md-12">
                      <small v-if="listOfRegistrationToExaminationTables && listOfRegistrationToExaminationTables.total"><b>({{ listOfRegistrationToExaminationTables.total }} registros)</b></small>
                    </div>
                  </div>

                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th>DNI</th>
                      <th>Alumno</th>
                      <td>Condición</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listOfRegistrationToExaminationTables.docs" :key="item._id">
                      <td>{{ item.file.personalData.dni }}</td>
                      <td>{{ item.file.personalData.lastName }} {{ item.file.personalData.firstName }}</td>
                      <td></td>
                    </tr>
                    <tr v-if="listOfRegistrationToExaminationTables && listOfRegistrationToExaminationTables.docs && listOfRegistrationToExaminationTables.docs.length === 0">
                      <td colspan="3">No se han encontrado inscripciones a esta materia.</td>
                    </tr>
                    <tr v-if="listOfRegistrationToExaminationTables && !listOfRegistrationToExaminationTables.docs">
                      <td colspan="3">Para poder visualizar la lista de alumnos inscriptos primero debes seleccionar los filtros...</td>
                    </tr>
                    </tbody>
                  </table>

                  <pagination  v-bind:current-page="params.page" v-bind:total-pages="listOfRegistrationToExaminationTables.pages" v-if="listOfRegistrationToExaminationTables && listOfRegistrationToExaminationTables.pages">
                  </pagination>

                </div>
              </div>
            </div>
          </div>
        </div> <!-- end col -->
      </div> <!-- end row -->

    </div><!-- container -->

  </div>
</template>


<script>
  import config from '../data/config'
  import pagination from '../components/Pagination.vue'
  import { required } from 'vuelidate/lib/validators'
  import subjectDuration from '../data/subjectDuration'
  import { downloadRegistrationToExaminationTablesList } from '../api'

  export default {

    name: 'registration-to-examination-tables-list-screen',


    components: {
      pagination
    },


    created () {

      this.$store.state.listOfRegistrationToExaminationTables = {};

      this.getAllCareers();
      this.getAllExaminationTables();

      this.$on('pageChanged:pagination', val => {
        this.params.page = val;
        this.getListOfRegistrationToExaminationTables();
      })

    },


    data () {

      return {

        params: {
          limit: config.pagination.limit,
          page: 1,
          examinationTable: null,
          subject: null,
          career: null,
          studyPlan: null,
          level: null
        },

        subjectDuration: subjectDuration,

        listOfStudyPlans: [],

        listOfLevels: [],

        listOfSubjects: []
      }

    },


    validations: {
      params: {
        examinationTable: {
          required
        },
        subject: {
          required
        },
        career: {
          required
        },
        studyPlan: {
          required
        },
        level: {
          required
        }
      }
    },


    computed: {

      listOfRegistrationToExaminationTables: function () {
        return this.$store.getters.getListOfRegistrationToExaminationTables
      },

      listOfCareers: function () {
        return this.$store.getters.getAllCareers
      },

      listOfExaminationTables: function () {
        return this.$store.getters.getAllExaminationTables
      },

    },



    methods: {

      download: function () {
        this.$v.params.$touch();

        if(!this.$v.params.$error) {
          $('.download').attr('disabled', true);

          downloadRegistrationToExaminationTablesList(this.params)
            .then(function (response) {
              let blob = new Blob([response.data], {type: response.headers['content-type']}),
                filename = 'inscriptos_a_mesas.xlsx';
              let result = document.createElement('a');
              result.href = window.URL.createObjectURL(blob);
              result.download = filename;
              result.click();
              $('.download').attr('disabled', false);
            })
            .catch((response) => {
              this.$message.error({text: response.message});
              $('.download').attr('disabled', false);
            })
        }
      },

      getListOfRegistrationToExaminationTables () {
        this.$v.params.$touch();

        if(!this.$v.params.$error) {
          this.$loader.loading();
          this.$store.dispatch('getListOfRegistrationToExaminationTables', {params: this.params})
            .then((response) => {
              this.$loader.close();
            })
            .catch((response) => {
              this.$loader.close();
              this.$message.error({text: response.message});
            })
        }
      },


      clearFilters() {
        this.params.page = 1;
        this.params.level = null;
        this.params.career = null;
        this.params.subject = null;
        this.params.examinationTable = null;
        this.params.studyPlan = null;

        this.$store.state.listOfRegistrationToExaminationTables = {};
      },


      search: function () {
          this.params.page = 1;
          this.getListOfRegistrationToExaminationTables();
      },


      getAllCareers () {
        this.$loader.loading();
        this.$store.dispatch('getAllCareers')
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },


      getAllExaminationTables () {
        this.$loader.loading();
        this.$store.dispatch('getAllExaminationTables')
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },


      getListOfStudyPlans () {
        const self = this;

        self.params.studyPlan = null;
        self.params.level = null;
        self.params.subject = null;

        var careerSelected = this.listOfCareers.filter(function (item) {
          return self.params.career === item._id;
        });
        if(careerSelected && careerSelected.length > 0) {
          careerSelected = careerSelected[0];
        }

        self.listOfStudyPlans = careerSelected.studyPlans;
      },


      getListOfLevels () {
        const self = this;

        self.params.level = null;
        self.params.subject = null;

        var selected = this.listOfStudyPlans.filter(function (item) {
          return self.params.studyPlan === item._id;
        });
        if(selected && selected.length > 0) {
          selected = selected[0];
        }

        self.listOfLevels = selected.levels;
      },


      getListOfSubjects () {
        const self = this;

        self.params.subject = null;

        var selected = this.listOfLevels.filter(function (item) {
          return self.params.level === item._id;
        });
        if(selected && selected.length > 0) {
          selected = selected[0];
        }

        self.listOfSubjects = selected.subjects;
      },

      getSubjectDuration: function (key) {
        var subjectDuration = this.subjectDuration.filter(function (item) {
          return key === item.value;
        });
        if(subjectDuration && subjectDuration.length > 0) {
          return '(' + subjectDuration[0].text + ')';
        }

        return '';
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/screens/RegistrationToExaminationTablesListScreen.vue